export function disableBodyScroll() {
  const scrollBarWidth =
    window.innerWidth - document.documentElement.clientWidth
  document.body.style.overflow = 'hidden'
  document.body.style.paddingRight = `${scrollBarWidth}px`
}

export function enableBodyScroll() {
  document.body.style.overflow = ''
  document.body.style.paddingRight = ''
}
